import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AssetSubscriptionV26 } from 'src/app/models-v26/asset-subscription-v26';
import { DeliveryItemV26 } from 'src/app/models-v26/deliveryitem-v26';
import { ActionResponse } from 'src/app/models/action-response';
import { Desk } from 'src/app/models/desk';
import { ReactivateAssetAdditionalInfoV26 } from 'src/app/shared-components-v26/allocation-wizard-modal-dialogs/reactivate-asset-wizard/additional-step/additional-info';
import { ReactivateAssetInitStepV26 } from 'src/app/shared-components-v26/allocation-wizard-modal-dialogs/reactivate-asset-wizard/init-step/init-step';
import { ReactivateAssetDueDatesV26 } from 'src/app/shared-components-v26/allocation-wizard-modal-dialogs/reactivate-asset-wizard/init-step/reactivate-asset-due-date-info';
import * as fromOrderWizardV26 from './reducer';
import { State } from './state';

export const selectReactivateAssetWizardState = createFeatureSelector<State>(fromOrderWizardV26.reactivateAssetWizardFeatureKey);

export const selectInitStep = createSelector(
  selectReactivateAssetWizardState,
  (state: State): ReactivateAssetInitStepV26 => state.initStep,
);

export const selectAssetServicesInitStep = createSelector(
  selectReactivateAssetWizardState,
  (state: State): AssetSubscriptionV26[] => state.initAssetServiceStep,
);

export const selectDeskStep = createSelector(selectReactivateAssetWizardState, (state: State): Desk => state.deskStep);

export const selectProductStep = createSelector(selectReactivateAssetWizardState, (state: State): DeliveryItemV26 => state.productStep);

export const selectDueDateStep = createSelector(
  selectReactivateAssetWizardState,
  (state: State): ReactivateAssetDueDatesV26 => state.dueDatesStep,
);

export const selectServiceStep = createSelector(selectReactivateAssetWizardState, (state: State): DeliveryItemV26[] => state.serviceStep);

export const selectAdditionaInfoStep = createSelector(
  selectReactivateAssetWizardState,
  (state: State): ReactivateAssetAdditionalInfoV26 => state.addInfoStep,
);

export const selectNewOrderState = createSelector(
  selectReactivateAssetWizardState,
  (state: State): ActionResponse => state.newOrderResponse,
);

export const selectErrorMessage = createSelector(selectReactivateAssetWizardState, (state: State): string => state.errorMessage);
